import React from 'react';
import EyeIcon from 'src/common/utils/TableColumnIcons/EyeIcon';

export const DetailSearchColumn = (
	value,
	row,
	rowIndex,
	{ onEye, arrayOrgan, accessAll }
) => {
	let isDisable = true;

	if (accessAll) isDisable = false;
	else if (arrayOrgan.includes(Number(row.organoId))) isDisable = false;

	return (
		<>
			<EyeIcon onClick={() => onEye(value)} color="primary" disabled={isDisable} />
		</>
	);
};
